import { Container, BrandLink, LogoIcon, Wordmark, StoreBadgeContainer, StoreBadge } from './styles';
import { appStoreURL } from '../../constants/urls';

const Header = () => {
    return (
        <Container>
            <BrandLink href="/">
                <LogoIcon src="/logo192.png" alt="Magic Crayons app icon" />
                <Wordmark>Magic Crayons</Wordmark>
            </BrandLink>
            <StoreBadgeContainer href={appStoreURL}>
                <StoreBadge src="/assets/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
            </StoreBadgeContainer>
        </Container>
    );
}

export default Header;
